import { accordionAction, counterAction, drawerAction, getInstapost, hideElement, hideLoader, hideSubMenu, showElement, showSubMenu } from './js-utils-3.js';
import { initSwipersAction } from './js-swipers.js';
import { cartAction, productOptionsAction } from './js-cart.js';
// ===== addEventListener =====
document.addEventListener('DOMContentLoaded', handleDOMContentLoaded);
window.addEventListener('load', handleWindowLoaded);
document.addEventListener('click', handleClick);
// ===== function =====
function handleDOMContentLoaded() {
  handleFormSubmit();
  initSwipersAction();
  getInstapost();
}
function handleWindowLoaded() {
  hideLoader();
}
function handleClick(e) {
  const target = e.target;

  if (target?.hasAttribute('data-product-option')) productOptionsAction(e);
  if (target?.hasAttribute('data-accordion-btn')) accordionAction(e);
  if (target?.hasAttribute('data-counter-btn')) counterAction(e);
  if (target?.hasAttribute('data-drawer-name')) drawerAction(e);
  if (target?.hasAttribute('data-cart')) cartAction(e);
  if (target?.hasAttribute('data-submenu-show')) showSubMenu(e);
  if (target?.hasAttribute('data-submenu-hide')) hideSubMenu(e);
}

function handleFormSubmit() {
  const hashValue = window.location.hash.replace(/^#/, '');
  const formRef = document.getElementById(`${hashValue}`);
  const formBoxRef = formRef?.closest('[data-form-box]');
  const formMsgSuccessRef = formBoxRef?.querySelector("[data-form-msg='success']");

  if (!formMsgSuccessRef) return;

  hideElement(formRef);
  showElement(formMsgSuccessRef);
}
